/* eslint-disable */

import React, { useContext } from "react";
import { Dropdown } from "@carbon/react";
import SectionHeader from "../components/section/SectionHeader";
import NewTranslationForm from "../components/organizationTranslation/NewOrganizationTranslationForm";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import OrgContext from "../store/orgContext";
import InfoAlert from "../ui/InfoAlert";
import { CREATE_ORG_TRANSLATION_TRANSLATIONS } from "../translations/util";

const NewOrganisationTranslation = () => {
  const { selectedOrg, selectedTranslationType, updateTranslationType } =
    useContext(OrgContext);

  return (
    <>
      <SectionHeader
        pageTitle={CREATE_ORG_TRANSLATION_TRANSLATIONS.header}
        pageDescription={CREATE_ORG_TRANSLATION_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={
          <div className="dropdown-details">
            <ESOganisationDropdown disabled org={selectedOrg || undefined} />
            {selectedOrg ? (
              <Dropdown
                className="translation-dropdown"
                titleText={
                  CREATE_ORG_TRANSLATION_TRANSLATIONS.translationDropdownText
                }
                label={CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown.label}
                selectedItem={selectedTranslationType}
                items={[
                  {
                    id: "floor-control",
                    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown
                      .dropdownItems["floor-control"],
                    disabled: true,
                  },
                  {
                    id: "P25-TO-MC-FC-PRI",
                    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown
                      .dropdownItems["P25-TO-MC-FC-PRI"],
                  },
                  {
                    id: "MC-TO-P25-FC-PRI",
                    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown
                      .dropdownItems["MC-TO-P25-FC-PRI"],
                  },
                  {
                    id: "DMR-TO-MC-FC-PRI",
                    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown
                      .dropdownItems["DMR-TO-MC-FC-PRI"],
                  },
                  {
                    id: "MC-TO-DMR-FC-PRI",
                    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown
                      .dropdownItems["MC-TO-DMR-FC-PRI"],
                  },
                ]}
                itemToString={(item: { text: any }) => (item ? item.text : "")}
                onChange={({ selectedItem }: any) => {
                  updateTranslationType(selectedItem);
                }}
              />
            ) : null}
          </div>
        }
      />

      <div className="main-content">
        {selectedOrg && selectedTranslationType ? (
          <NewTranslationForm
            org={selectedOrg.id}
            type={selectedTranslationType.id}
          />
        ) : (
          <InfoAlert
            heading={CREATE_ORG_TRANSLATION_TRANSLATIONS.infoAlert.heading}
            subText={CREATE_ORG_TRANSLATION_TRANSLATIONS.infoAlert.subText}
          />
        )}
      </div>
    </>
  );
};

export default NewOrganisationTranslation;
